export const Actions = {

    ACTION_1: {text: 'Ausjäten', value: 'action1'},
    ACTION_2: {text: 'Ausreißen', value: 'action2'},
    ACTION_3: {text: 'Abmähen', value: 'action3'},
    ACTION_4: {text: 'Ausgraben/Aushacken', value: 'action4'},
    ACTION_5: {text: 'Ausbringen von Pflanzenschutzmittel', value: 'action5'},
    ACTION_6: {text: 'Beweiden', value: 'action6'},
    ACTION_7: {text: 'Mulchen', value: 'action7'},
    ACTION_8: {text: 'Kontrollieren', value: 'action8'},
    ACTION_9: {text: 'Heißdampf Anwendung', value: 'action9'},
    ACTION_10: {text: 'Ersterhebung', value: 'action10'},
    ACTION_11: {text: 'Ringeln', value: 'action11'},
    ACTION_12: {text: 'Beschatten des Bestandes/Einsäen', value: 'action12'},

    list() {
        return [
            this.ACTION_3,
            this.ACTION_5,
            this.ACTION_4,
            this.ACTION_1,
            this.ACTION_2,
            this.ACTION_12,
            this.ACTION_6,
            this.ACTION_10,
            this.ACTION_9,
            this.ACTION_8,
            this.ACTION_7,
            this.ACTION_11,
        ]
    },

    itemByValue(value) {
        let action =this.list().find(item => item.value === value)
        return typeof(action)==="undefined" ? false: action
    }
}
